import React from 'react';
import ListInput from './ListInput';
import NumericInput from './NumericInput';
import SelectorInput from './SelectorInput';
import StringInput from './StringInput';

const ValueInput = ({
  operatorCategory = 'string',
  value,
  onChange,
  placeholder = '',
  disabled = false,
  selectorOptions = [],
}) => {
  // Type NUMERIC : InputNumber pour les nombres (float)
  if (operatorCategory === 'numeric') {
    return (
      <NumericInput
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
      />
    );
  }

  // Type STRING : Input standard pour le texte
  if (operatorCategory === 'string') {
    return (
      <StringInput
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
      />
    );
  }

  // Type LIST : Système de tags
  if (operatorCategory === 'list') {
    return <ListInput value={value} onChange={onChange} disabled={disabled} />;
  }

  // Type LOGICAL : Rendu récursif pour les opérateurs logiques (AND/OR)
  if (operatorCategory === 'logical') {
    return;
  }

  // Type SELECTOR : Select avec options prédéfinies (pour les attributs de type list)
  if (operatorCategory === 'selector') {
    return (
      <SelectorInput
        value={value}
        onChange={onChange}
        options={selectorOptions}
        disabled={disabled}
      />
    );
  }

  // Fallback : Input standard par défaut
  return (
    <StringInput
      value={value}
      onChange={onChange}
      placeholder={placeholder || 'Entrez une valeur'}
      disabled={disabled}
    />
  );
};

export default ValueInput;
